// @ts-expect-error * Automated Type Error Fix
export function shuffle(array, limit) {
    // @ts-expect-error * Automated Type Error Fix
    const new_arr = [];
    while (new_arr.length < array.length && new_arr.length < limit) {
        const random_item = array[Math.floor(Math.random() * array.length)];
        // @ts-expect-error * Automated Type Error Fix
        if (!new_arr.includes(random_item)) {
            new_arr.push(random_item);
        }
    }
    return new_arr;
}
